import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Breaking(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.146 13.647l-.002.002.002-.002.02-.023c.02-.023.051-.06.09-.112a3.2 3.2 0 00.297-.486c.22-.438.447-1.112.447-2.026 0-.914-.228-1.588-.447-2.026a3.197 3.197 0 00-.297-.486 1.916 1.916 0 00-.11-.134l-.002-.003a.5.5 0 01.71-.705v.001l.001.001.002.002.005.005.014.015.043.048c.035.04.082.096.137.17.11.146.251.359.391.638.28.562.553 1.388.553 2.474 0 1.086-.272 1.912-.553 2.474a4.19 4.19 0 01-.39.639 2.908 2.908 0 01-.2.237l-.002.002-.001.002a.5.5 0 01-.71-.705",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.496 16.972a.5.5 0 01-.038-.707l.05-.061c.04-.05.097-.126.168-.232.142-.21.337-.535.533-.972.391-.874.791-2.204.791-4 0-1.796-.4-3.126-.791-4a6.514 6.514 0 00-.533-.972 3.965 3.965 0 00-.21-.284l-.008-.01a.5.5 0 01.744-.668l.001.001.028.032.064.079c.053.067.125.164.21.291.172.254.395.628.616 1.122.444.99.879 2.46.879 4.409 0 1.949-.435 3.418-.879 4.409a7.523 7.523 0 01-.615 1.122 4.904 4.904 0 01-.303.403l-.745-.669.744.67a.5.5 0 01-.706.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.793 3.704c.63-.63 1.707-.184 1.707.707v13.171c0 .891-1.077 1.337-1.707.707l-3-3a1 1 0 00-.707-.293H3.5a1 1 0 01-1-1v-6a1 1 0 011-1h6.586a1 1 0 00.707-.292l3-3zM11.5 7.41l3-3v13.171l-3-3a2 2 0 00-1.414-.586H3.5v-6h6.586a2 2 0 001.414-.585z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 19v-4h1v4a.5.5 0 00.5.5h1A.5.5 0 008 19v-4h1v4a1.5 1.5 0 01-1.5 1.5h-1A1.5 1.5 0 015 19z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Breaking);
export default ForwardRef;